import SessionStorage from "sessionstorage";
import axios from "axios";
import _ from "underscore";
import {APIHOST, MOMENT_API_DATE_FORMAT, MOMENT_API_DATETIME_FORMAT} from "@/settings";
import PrintJs from 'print-js'
import moment from 'moment';
import {jsonDataToExcel} from "@/js/XLSX";
import Mapper from "@/helpers/mappers"

class ShipmentService {
    register({
                 orderId,

                 isTrailer,
                 isSemiTrailer,
                 trailerSerialNumber,
                 trailerModel,

                 number,
                 date,

                 wayPathNumber,
                 wayPathDate,

                 contractNumber,
                 contractDate,

                 driverName,
                 carNumber,
                 carModel,

                 customerInn,
                 customerName,

                 consigneeInn,
                 consigneeName,

                 deliveryAddress,
                 loadingAddress,

                 deliveryDateTime,

                 total,
                 totalInWord,

                 items
             }) {
        const oAuthAccess = JSON.parse(SessionStorage.getItem('auth_token'));

        return axios.post(`${APIHOST}/api/RegisterShipmentWaybill`, {
            OrderId: orderId,

            IsTrailer: isTrailer,
            IsSemiTrailer: isSemiTrailer,
            TrailerSerialNumber: trailerSerialNumber,
            TrailerModel: trailerModel,

            WaypathBillNumber: wayPathNumber,
            WaypathBillDate: wayPathDate.format(MOMENT_API_DATE_FORMAT),

            Number: number,
            Date: date.format(MOMENT_API_DATE_FORMAT),

            ContractNumber: contractNumber,
            ContractDate: contractDate.format(MOMENT_API_DATE_FORMAT),

            DriverName: driverName,
            CarSerialNumber: carNumber,
            CarModel: carModel,
            CustomerInn: customerInn,
            CustomerName: customerName,
            ConsigneeInn: consigneeInn,
            ConsigneeName: consigneeName,
            DeliveryAddress: deliveryAddress,
            LoadingAddress: loadingAddress,
            DeliveryDateTime: deliveryDateTime.format(MOMENT_API_DATETIME_FORMAT),
            Total: total,
            TotalInWords: totalInWord,

            Items: _.map(items, i => {
                return {
                    OrderItemId: i.orderItemId,
                    Product: i.product,
                    CustomerCode: i.customerCode,
                    Measurement: i.measurement,
                    Quantity: i.quantity,
                    Price: i.price,
                    Total: i.total,
                    NdsRate: i.ndsRate,
                    NdsValue: i.ndsValue,
                    TotalWithNds: i.totalWithNds,
                    CatalogCode: i.catalogCode,
                    CatalogName: i.catalogName
                }
            })
        }, {
            headers: {
                'Authorization': `Bearer ${oAuthAccess.access_token}`
            }
        });
    }

    edit(id, {
        isTrailer,
        isSemiTrailer,
        trailerSerialNumber,
        trailerModel,

        number,
        date,

        wayPathNumber,
        wayPathDate,

        contractNumber,
        contractDate,

        driverName,
        carNumber,
        carModel,

        customerInn,
        customerName,

        consigneeInn,
        consigneeName,

        deliveryAddress,
        loadingAddress,

        deliveryDateTime,

        total,
        totalInWord,

        items
    }) {
        const oAuthAccess = JSON.parse(SessionStorage.getItem('auth_token'));

        return axios.put(`${APIHOST}/api/RegisterShipmentWaybill/${id}`, {
            IsTrailer: isTrailer,
            IsSemiTrailer: isSemiTrailer,
            TrailerSerialNumber: trailerSerialNumber,
            TrailerModel: trailerModel,

            WaypathBillNumber: wayPathNumber,
            WaypathBillDate: moment(wayPathDate).format(MOMENT_API_DATE_FORMAT),

            Number: number,
            Date: moment(date).format(MOMENT_API_DATE_FORMAT),

            ContractNumber: contractNumber,
            ContractDate: moment(contractDate).format(MOMENT_API_DATE_FORMAT),

            DriverName: driverName,
            CarSerialNumber: carNumber,
            CarModel: carModel,
            CustomerInn: customerInn,
            CustomerName: customerName,
            ConsigneeInn: consigneeInn,
            ConsigneeName: consigneeName,
            DeliveryAddress: deliveryAddress,
            LoadingAddress: loadingAddress,
            DeliveryDateTime: moment(deliveryDateTime).format(MOMENT_API_DATETIME_FORMAT),

            Total: total,
            TotalInWords: totalInWord,

            Items: _.map(items, i => {
                return {
                    OrderItemId: i.orderItemId,
                    Product: i.product,
                    Measurement: i.measurement,
                    CustomerCode: i.customerCode,
                    Quantity: i.quantity,
                    Price: i.price,
                    Total: i.total,
                    NdsRate: i.ndsRate,
                    NdsValue: i.ndsValue,
                    TotalWithNds: i.totalWithNds,
                    CatalogCode: i.catalogCode,
                    CatalogName: i.catalogName
                }
            })
        }, {
            headers: {
                'Authorization': `Bearer ${oAuthAccess.access_token}`
            }
        });
    }

    getAllbox({
                  sortBy,
                  sortDesc,
                  skip,
                  limit,
                  order,
                  deliveryDate,
                  q,
                  branch,
                  date,
                  start,
                  end,
                  isExecutorApproved,
                  isCustomerApproved,
                  isDeclined,
                  hasInvoice,
                  status,
                  statuses
              }) {
        const oAuthAccess = JSON.parse(SessionStorage.getItem('auth_token'));

        return axios.get(`${APIHOST}/api/ShipmentWaybillAllbox`, {
            params: {
                sortBy: sortBy,
                desc: sortDesc,
                skip: skip,
                limit: limit,
                order: order ? order : null,
                deliveryDate: deliveryDate ? deliveryDate.toISOString(true) : null,
                q: typeof (q) === 'undefined' ? null : q,
                branch: typeof (branch) === 'undefined' ? null : branch,
                date: date ? date.format(MOMENT_API_DATE_FORMAT) : null,
                start: start ? start.format(MOMENT_API_DATE_FORMAT) : null,
                end: end ? end.format(MOMENT_API_DATE_FORMAT) : null,
                isExecutorApproved: typeof (isExecutorApproved) === 'boolean' ? isExecutorApproved : null,
                isCustomerApproved: typeof (isCustomerApproved) === 'boolean' ? isCustomerApproved : null,
                isDeclined: typeof (isDeclined) === 'boolean' ? isDeclined : null,
                hasInvoice: typeof (hasInvoice) === 'boolean' ? hasInvoice : null,
                status: typeof(status) === 'number' ? status: null,
                statuses : statuses
            },
            headers: {
                'Authorization': `Bearer ${oAuthAccess.access_token}`
            }
        });
    }

    getInfo(id) {
        const oAuthAccess = JSON.parse(SessionStorage.getItem('auth_token'));

        return axios.get(`${APIHOST}/api/ShipmentWaybillInfo/${id}`, {
            headers: {
                'Authorization': `Bearer ${oAuthAccess.access_token}`
            }
        });
    }

    getShipmentWaybillAttorney(id) {
        const oAuthAccess = JSON.parse(SessionStorage.getItem('auth_token'));

        return axios.get(`${APIHOST}/api/ShipmentWaybillAttorney/${id}`, {
            headers: {
                'Authorization': `Bearer ${oAuthAccess.access_token}`
            }
        });
    }

    accept(id) {
        const oAuthAccess = JSON.parse(SessionStorage.getItem('auth_token'));

        return axios.put(`${APIHOST}/api/AcceptShipmentWaybill/${id}`, {}, {
            headers: {'Authorization': `Bearer ${oAuthAccess.access_token}`}
        });
    }

    approve(id, comment) {
        const oAuthAccess = JSON.parse(SessionStorage.getItem('auth_token'));

        return axios.put(`${APIHOST}/api/ApproveShipment/${id}`, {Comment: comment}, {
            headers: {'Authorization': `Bearer ${oAuthAccess.access_token}`}
        });
    }

    decline(id, reason, comment) {
        const oAuthAccess = JSON.parse(SessionStorage.getItem('auth_token'));

        const data = {
            Reason: reason,
            Comment: comment
        }

        return axios.put(`${APIHOST}/api/DeclineShipmentWaybill/${id}`, data, {
            headers: {'Authorization': `Bearer ${oAuthAccess.access_token}`}
        });
    }

    delete(id,data) {
        const oAuthAccess = JSON.parse(SessionStorage.getItem('auth_token'));

        return axios.put(`${APIHOST}/api/DeleteShipment/${id}`, data,{
            headers: {'Authorization': `Bearer ${oAuthAccess.access_token}`}
        });
    }

    printPdf(id) {
        const oAuthAccess = JSON.parse(SessionStorage.getItem('auth_token'));
        const promise = axios.get(`${APIHOST}/api/ShipmentWaybillPdf`, {
            responseType: 'blob',
            headers: {
                'Authorization': `Bearer ${oAuthAccess.access_token}`
            },
            params: {id: id}
        });

        promise.then(response => {
            const blob = new Blob([response.data]);
            const url = window.URL.createObjectURL(blob);

            PrintJs(url);
        });

        return promise;
    }

    downloadExcelSingle(id) {
        return new Promise((resolve, reject) => {
            this.getInfo(id)
                .then(response => {
                    const shipment = Mapper.mapShipmentInfo(response.data)

                    const numberField = 'Номер'
                    const dateField = 'Дата'
                    const branchField = 'Магазин'
                    const waybillNumberField = 'Номер путевого листа'
                    const waybillDateField = 'Дата путевого листа'
                    const invoiceNumberField = 'Номер счёт-фактуры'
                    const invoiceDateField = 'Дата счёт-фактуры'
                    const totalField = 'Сумма'
                    const contractNumberField = 'Номер договора'
                    const contractDateField = 'Дата договора'

                    let excelData = []

                    let shipmentMetaRow = {}
                    shipmentMetaRow[branchField] = shipment.deliveryAddress
                    shipmentMetaRow[numberField] = shipment.number;
                    shipmentMetaRow[dateField] = shipment.date.format('DD.MM.YYYY');
                    shipmentMetaRow[totalField] = shipment.total;
                    shipmentMetaRow[waybillNumberField] = shipment.waybillNumber;
                    shipmentMetaRow[waybillDateField] = shipment.waybillDate.format('DD.MM.YYYY');
                    shipmentMetaRow[invoiceNumberField] = shipment.invoice ? shipment.invoice.number : '';
                    shipmentMetaRow[invoiceDateField] = shipment.invoice ? shipment.invoice.date.format('DD.MM.YYYY') : ''
                    shipmentMetaRow[contractNumberField] = shipment.contractNumber;
                    shipmentMetaRow[contractDateField] = shipment.contractDate.format('DD.MM.YYYY');
                    excelData.push(shipmentMetaRow)

                    // empty row
                    excelData.push({})

                    let itemsHeaderRow = {}
                    itemsHeaderRow[branchField] = '№'
                    itemsHeaderRow[numberField] = 'Товар'
                    itemsHeaderRow[dateField] = 'Штрих-код'
                    itemsHeaderRow[totalField] = 'Ед.изм'
                    itemsHeaderRow[waybillNumberField] = 'Количество'
                    itemsHeaderRow[waybillDateField] = 'Цена за единицу'
                    itemsHeaderRow[invoiceNumberField] = 'Стоимость'
                    itemsHeaderRow[invoiceDateField] = 'НДС ставка'
                    itemsHeaderRow[contractNumberField] = 'НДС сумма'
                    itemsHeaderRow[contractDateField] = 'Сумма'
                    excelData.push(itemsHeaderRow)


                    _.each(shipment.items, (item, index) => {
                        let itemRow = {}

                        itemRow[branchField] = ` ${index + 1}`
                        itemRow[numberField] = item.product
                        itemRow[dateField] = item.customerCode
                        itemRow[totalField] = item.measurement
                        itemRow[waybillNumberField] = item.quantity
                        itemRow[waybillDateField] = item.price
                        itemRow[invoiceNumberField] = item.total
                        itemRow[invoiceDateField] = item.ndsRate
                        itemRow[contractNumberField] = item.ndsValue
                        itemRow[contractDateField] = item.totalWithNds

                        excelData.push(itemRow)
                    })

                    jsonDataToExcel(excelData, `Поставка в ${response.data.DeliveryAddress} от ${moment(response.data.Date).format('DD-MM-YYYY')} на ${response.data.Total} сум.xlsx`)

                    resolve()
                }, reject)
        })
    }

    downloadExcelAll(params) {
        return new Promise((resolve, reject) => {
            this.getAllbox(params)
                .then(response => {
                    // todo implement invoice logic

                    const numberField = 'Номер'
                    const dateField = 'Дата'
                    const branchField = 'Магазин'
                    const waybillNumberField = 'Номер путевого листа'
                    const waybillDateField = 'Дата путевого листа'
                    const invoiceNumberField = 'Номер счёт-фактуры'
                    const invoiceDateField = 'Дата счёт-фактуры'
                    const totalField = 'Сумма'
                    const contractNumberField = 'Номер договора'
                    const contractDateField = 'Дата договора'

                    let excelData = []

                    _.each(response.data.Records, shipmentRecord => {
                        const shipment = Mapper.mapShipment(shipmentRecord)

                        let shipmentMetaRow = {}

                        shipmentMetaRow[branchField] = shipment.deliveryAddress
                        shipmentMetaRow[numberField] = shipment.number;
                        shipmentMetaRow[dateField] = shipment.date.format('DD.MM.YYYY');
                        shipmentMetaRow[totalField] = shipment.total;
                        shipmentMetaRow[waybillNumberField] = shipment.waybillNumber;
                        shipmentMetaRow[waybillDateField] = shipment.waybillDate.format('DD.MM.YYYY');
                        shipmentMetaRow[invoiceNumberField] = shipment.invoice ? shipment.invoice.number : '';
                        shipmentMetaRow[invoiceDateField] = shipment.invoice ? shipment.invoice.date.format('DD.MM.YYYY') : ''
                        shipmentMetaRow[contractNumberField] = shipment.contractNumber;
                        shipmentMetaRow[contractDateField] = shipment.contractDate.format('DD.MM.YYYY');
                        excelData.push(shipmentMetaRow)
                    })

                    jsonDataToExcel(excelData, `Реестр поставок.xlsx`)

                    resolve()
                }, reject)
        })
    }
}

export default new ShipmentService();